import { all } from 'redux-saga/effects';
import App from './App/saga';
import Auth from './Auth/saga';
import Dashboard from './Dashboard/saga';
import DashboardDokter from './DashboardDokter/saga';
import DashboardApotek from './DashboardApotek/saga';
import ModulePasien from './ModulePasien/saga';
import ModuleLayanan from './ModuleLayanan/saga';
import ModulePoli from './ModulePoli/saga';
import ModuleObat from './ModuleObat/saga';
import ModuleDokter from './ModuleDokter/saga';
import ModuleReservasi from './ModuleReservasi/saga';
import ModuleKasir from './ModuleKasir/saga';
import ModuleUserMedis from './ModuleUserMedis/saga';
import ModuleRekamMedis from './ModuleRekamMedis/saga';
import ModuleReport from './ModuleReport/saga';


export default function* rootSaga(getState) {
  yield all([
    App(),
    Auth(),
    Dashboard(),
    ModulePasien(),
    ModuleLayanan(),
    ModulePoli(),
    ModuleObat(),
    ModuleDokter(),
    ModuleReservasi(),
    DashboardDokter(),
    DashboardApotek(),
    ModuleKasir(),
    ModuleUserMedis(),
    ModuleRekamMedis(),
    ModuleReport(),

  ]);
}
